module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header-main"
  }, [_c('div', {
    staticClass: "page-header navbar navbar-fixed-top"
  }, [_c('div', {
    staticClass: "page-header-inner"
  }, [_c('div', {
    staticClass: "page-logo",
    staticStyle: {
      "width": "133px"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/admin/dashboard"
    }
  }, [_c('img', {
    staticClass: "logo-default",
    attrs: {
      "src": "/static/layouts/layout2/img/logo-default.png",
      "alt": "logo"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu-toggler sidebar-toggler"
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "menu-toggler responsive-toggler",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "collapse",
      "data-target": ".navbar-collapse"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "page-top"
  }, [(_vm.user.access > 1) ? _c('autocomplete', {
    attrs: {
      "selection": _vm.value
    },
    on: {
      "update:selection": function($event) {
        _vm.value = $event
      },
      "searchQuery": _vm.displaySearchQuery,
      "openSearchModal": _vm.openSearchModal
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "top-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav pull-right"
  }, [(_vm.showMessages) ? _c('inbox', {
    attrs: {
      "user": _vm.user
    }
  }) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "dropdown dropdown-user"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown",
      "data-hover": "dropdown",
      "data-close-others": "true"
    }
  }, [_c('avatar', {
    attrs: {
      "username": _vm.name,
      "src": _vm.avatar,
      "size": 40,
      "rounded": true,
      "color": "#d09f23",
      "backgroundColor": "#eef1f5"
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "fa fa-angle-down"
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-default"
  }, [_c('li', [(_vm.user.access > 1) ? _c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showProfileModal.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "icon-user"
  }), _vm._v(" My Profile\n                  ")]) : _vm._e()]), _vm._v(" "), (false) ? _c('li', [_vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.user.access > 1) ? _c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showTimeZoneModal.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "icon-clock"
  }), _vm._v(" Time Zone Settings\n                  ")])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "divider"
  }), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": _vm.logoutMe
    }
  }, [_c('i', {
    staticClass: "icon-lock"
  }), _vm._v(" Log Out ")])])])])], 1)])], 1)])]), _vm._v(" "), _c('search-modal', {
    attrs: {
      "query": _vm.searchValue,
      "refreshSearch": _vm.refreshSearch
    }
  }), _vm._v(" "), _c('my-profile', {
    on: {
      "avatarUpdate": _vm.updateAvatar
    }
  }), _vm._v(" "), _c('user-profile', {
    on: {
      "avatarUpdate": _vm.updateAvatar
    }
  }), _vm._v(" "), _c('time-zone')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-actions"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_vm._v("  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "#.html"
    }
  }, [_c('i', {
    staticClass: "icon-envelope-open"
  }), _vm._v(" Email Settings\n                    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-15d8703e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/Header.vue
// module id = 1564
// module chunks = 1